const LOG = {
    // H5页面访问（PV UV）
    send_pvuv() {},
    // 点击主链接
    send_pv_mainlink() {
        fbq('track', 'CustomizeProduct');
        fbq('trackCustom', 'pv_mainlink');

        gtag('event', 'pv_mainlink');
    },
    // 点击分享链接
    send_pv_sharelink() {
        fbq('track', 'StartTrial');
        fbq('trackCustom', 'pv_sharelink');

        gtag('event', 'pv_sharelink');
    },
    // 点击登录Facebook
    send_click_login_fb() {
        fbq('track', 'SubmitApplication');
        fbq('trackCustom', 'click_login_facebook');

        gtag('event', 'click_login_facebook');
    },
    // 点击登录WhatsApp
    send_click_login_wa() {
        fbq('track', 'Search');
        fbq('trackCustom', 'click_login_whatsapp');

        gtag('event', 'click_login_whatsapp');
    },
    // 点击登录VK
    send_click_login_vk() {
        fbq('track', 'ViewContent');
        fbq('trackCustom', 'click_login_vk');

        gtag('event', 'click_login_vk');
    },
    // 点击确认领养
    send_click_adopt_dragon() {
        fbq('track', 'AddPaymentInfo');
        fbq('trackCustom', 'click_adopt_dragon');

        gtag('event', 'click_adopt_dragon');
    },
    // 点击分享
    send_click_share(channel) {
        fbq('track', 'Lead');
        fbq('trackCustom', 'click_share', {
            channel
        });

        gtag('event', 'click_share', {
            value: channel
        });
    },
    // 点击转盘抽奖
    send_click_draw() {
        fbq('track', 'Contact');
        fbq('trackCustom', 'click_draw');

        gtag('event', 'click_draw');
    },
    // 兑换成功
    send_click_exchange() {
        fbq('track', 'FindLocation');
        fbq('trackCustom', 'click_exchange');

        gtag('event', 'click_exchange');
    },
    // 点击“好友页”再次对战
    send_click_battlewithfriends() {
        fbq('track', 'Schedule');
        fbq('trackCustom', 'click_battlewithfriends');

        gtag('event', 'click_battlewithfriends');
    }
};

export default LOG;

// FB 标准事件
// fbq('track', 'Purchase', {currency: "USD", value: 30.00});

// FB 自定义事件
// fbq('trackCustom', 'ShareDiscount', {promotion: 'share_discount_10%'});
